import { RealTimeSidebarController } from './dashboard/realTimeSidebar/RealTimeSidebarController';
import RealTimeSidebarView from './dashboard/realTimeSidebar/RealTimeSidebarView.html';
import { TransferTicketModalController } from './dashboard/transferTicketModal/TransferTicketModalController';
import TransferTicketModalView from './dashboard/transferTicketModal/TransferTicketModalView.html';
import { TAG_KEY } from 'modules/application/detail/attendance/generalsettings/GeneralSettingsController';
import { CloseTicketModalController } from './dashboard/closeTicketModal/CloseTicketModalController';
import CloseTicketModalView from './dashboard/closeTicketModal/CloseTicketModalView.html';
import { sortTags } from 'data/function';
import { AttendanceConstants } from './AttendanceConstants';
import { AttendanceFeatures } from './AttendanceFeatures';
export class RealtimeSidebarService {
    static $inject = ['$document', 'DeskConfigurationService', 'SidebarContentService', 'CurrentApplicationService', 'dashboardRealTimeMonitoringService', 'MESSAGINGHUBDOMAIN', 'TeamService', 'DashboardService', 'BucketService', 'ngToast', 'ModalService', '$translate', 'BlipToastService'];
    constructor($document, DeskConfigurationService, SidebarContentService, CurrentApplicationService, dashboardRealTimeMonitoringService, MESSAGINGHUBDOMAIN, TeamService, DashboardService, BucketService, ngToast, ModalService, $translate, BlipToastService) {
        'ngInject';
        this.$document = $document;
        this.DeskConfigurationService = DeskConfigurationService;
        this.SidebarContentService = SidebarContentService;
        this.CurrentApplicationService = CurrentApplicationService;
        this.dashboardRealTimeMonitoringService = dashboardRealTimeMonitoringService;
        this.MESSAGINGHUBDOMAIN = MESSAGINGHUBDOMAIN;
        this.TeamService = TeamService;
        this.DashboardService = DashboardService;
        this.BucketService = BucketService;
        this.ngToast = ngToast;
        this.ModalService = ModalService;
        this.$translate = $translate;
        this.BlipToastService = BlipToastService;
    }
    async openRealtimeSidebar({ ticket, canTransferWithoutAgents }) {
        this.canTransferWithoutAgents = canTransferWithoutAgents;
        try {
            this.application = await this.CurrentApplicationService.fetchApplication();
            return await this.SidebarContentService.showSidebar({
                controller: RealTimeSidebarController,
                controllerAs: '$ctrl',
                template: RealTimeSidebarView,
                appendToElement: this.$document[0].getElementById('right-sidebar'),
                inputs: {
                    application: this.application,
                    from: `${this.application.shortName}@${this.MESSAGINGHUBDOMAIN}`,
                    to: ticket.customerIdentity,
                    ticket: ticket,
                    onUpdateTicket: this.setActiveTicket.bind(this),
                    onTransferTicket: this.transferTicket.bind(this),
                    onCloseTicket: this.closeTicket.bind(this),
                    canTransferWithoutAgents,
                },
            });
        }
        catch (error) {
            console.error(error);
        }
    }
    setActiveTicket(ticket) {
        this.activeThreadTicket = {
            ...ticket,
        };
    }
    async transferTicket(ticket, $event) {
        $event.stopPropagation();
        let modal;
        const isDirectTransferFeatureToggleEnabled = await AttendanceFeatures.isDirectTransferEnabled();
        const isConfigurationsApplicationsDomainUsageGetEnabled = await AttendanceFeatures.isUseConfigurationsDomainOnAttendanceOperationsGetEnabled();
        try {
            const { items } = await this.TeamService.getTeamsAndAgentsOnline(this.application);
            const attendants = await this.TeamService.getAllAttendants('', AttendanceConstants.DEFAULT_DIRECT_TRANSFER_REQUESTED_NUMBER_OF_AGENTS);
            const isDirectTransferEnabled = await this.DeskConfigurationService.getDeskConfiguration(AttendanceConstants.TRANSFER_DIRECTLY_CONFIG, false, isConfigurationsApplicationsDomainUsageGetEnabled);
            const isOrleansEnabled = await this.DeskConfigurationService.getDeskConfiguration(AttendanceConstants.DISTRIBUTION_TYPE, undefined, isConfigurationsApplicationsDomainUsageGetEnabled) === AttendanceConstants.ORLEANS_DISTRIBUTION;
            const isRedisEnabled = await this.DeskConfigurationService.getDeskConfiguration(AttendanceConstants.DISTRIBUTION_TYPE, undefined, isConfigurationsApplicationsDomainUsageGetEnabled) === AttendanceConstants.REDIS_DISTRIBUTION;
            modal = await this.ModalService.showModal({
                template: TransferTicketModalView,
                controller: TransferTicketModalController,
                controllerAs: '$ctrl',
                inputs: {
                    ticket: ticket,
                    teams: items,
                    attendants: attendants,
                    canTransferWithoutAgents: this.canTransferWithoutAgents,
                    isAttendantTransferEnabled: isDirectTransferFeatureToggleEnabled && isDirectTransferEnabled && (isOrleansEnabled || isRedisEnabled),
                },
            });
        }
        catch (e) {
            console.error(e);
            const errorMsg = await this.$translate('transferTicket.errorMsg.1', {
                sequentialId: ticket.sequentialId,
            });
            this.ngToast.danger(errorMsg);
        }
        const { recipient, isTeam } = await modal.close;
        try {
            isTeam ?
                await this.DashboardService.transferTicketToTeam(ticket.id, recipient) :
                await this.DashboardService.transferTicketToAgent(ticket.id, recipient);
            const successMsg = await this.$translate('utils.successMsg.42');
            const refreshText = await this.$translate('utils.forms.refresh');
            this.BlipToastService.show('success', {
                msg: successMsg,
                buttonText: refreshText,
                callback: () => this.dashboardRealTimeMonitoringService.refreshMonitoringScreen(),
            });
        }
        catch (e) {
            let errorMsg;
            if (e.message.endsWith('Ticket is already closed and cannot be updated')) {
                errorMsg = await this.$translate('utils.errorMsg.158', {
                    sequentialId: ticket.sequentialId,
                });
            }
            else {
                errorMsg = await this.$translate('utils.errorMsg.156', {
                    sequentialId: ticket.sequentialId,
                });
            }
            this.BlipToastService.show('danger', {
                msg: errorMsg,
            });
        }
        finally {
            this.dashboardRealTimeMonitoringService.refreshMonitoringScreen();
        }
    }
    async closeTicket(ticket, $event) {
        $event.stopPropagation();
        let resource, tags, hasTags, isTagsRequired;
        try {
            resource = await this.BucketService.get(TAG_KEY);
            resource = JSON.parse(resource);
            tags =
                resource.tags.sort(sortTags) ||
                    (Array.isArray(resource) ? resource : []);
            tags = tags.map((tag) => {
                return {
                    value: tag.text,
                    label: tag.text,
                };
            });
        }
        catch (err) {
            console.error(err);
            resource = {};
        }
        finally {
            if (!tags) {
                tags = [];
            }
            hasTags = resource.hasTags || false;
            isTagsRequired = resource.isTagsRequired || false;
        }
        let modal;
        try {
            modal = await this.ModalService.showModal({
                template: CloseTicketModalView,
                controller: CloseTicketModalController,
                controllerAs: '$ctrl',
                inputs: {
                    ticket: ticket,
                    tags,
                    hasTags,
                    isTagsRequired,
                },
            });
        }
        catch (e) {
            console.error(e);
            return;
        }
        const selectedTags = await modal.close;
        if (selectedTags) {
            try {
                ticket.tags = selectedTags;
                await this.DashboardService.closeTicket(ticket);
                const successMsg = await this.$translate('utils.successMsg.43', {
                    sequentialId: ticket.sequentialId,
                });
                this.ngToast.success(successMsg);
            }
            catch (e) {
                let errorMsg;
                if (e.message.endsWith('Ticket is already closed and cannot be updated')) {
                    errorMsg = await this.$translate('utils.errorMsg.158', {
                        sequentialId: ticket.sequentialId,
                    });
                }
                else {
                    errorMsg = await this.$translate('utils.errorMsg.166', {
                        sequentialId: ticket.sequentialId,
                    });
                }
                this.ngToast.danger(errorMsg);
            }
        }
    }
}
RealtimeSidebarService.$inject = ['$document', 'DeskConfigurationService', 'SidebarContentService', 'CurrentApplicationService', 'dashboardRealTimeMonitoringService', 'MESSAGINGHUBDOMAIN', 'TeamService', 'DashboardService', 'BucketService', 'ngToast', 'ModalService', '$translate', 'BlipToastService'];
